import React from 'react';
import { Grid, MenuItem, Select } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import useFormVisibilityStore from '../FormConditionStores/useFormVisibilityStore';
import ItemCondition from './ItemConditional';
import { Visibility, VisibilityOff } from '@mui/icons-material';

class ItemStatementCondition extends React.Component {
  render() {
    const { indexStatement, condition, AnswerList } = this.props;
    const { operators } = condition;

    return (
      <Grid container xs={12} direction={'column'} spacing={2}>
        {operators && operators.length > 0 ? (
          <React.Fragment>
            {operators &&
              operators.map((con, index) => {
                if (AnswerList !== undefined) {
                  return (
                    <Grid container item xs={12} direction={'row'}>
                      <ItemCondition
                        key={index}
                        indexCondition={index}
                        indexStatement={indexStatement}
                        FormStore={useFormVisibilityStore.getState()}
                        condition={con}
                        ConditionList={AnswerList.ConditionList[index]}
                        availablePlaceholders={this.props.availablePlaceholders}
                      />
                    </Grid>
                  );
                }
              })}
            <Grid xs={12} container item direction={'row'}>
              <Grid
                xs={5}
                alignItems={'center'}
                className={'text-button'}
                direction={'row'}
                container
                item
                onClick={() => useFormVisibilityStore.getState().addCondition(indexStatement)}
              >
                <AddIcon /> Add AND/OR condition
              </Grid>
            </Grid>
            <Grid xs={12} container item direction={'row'} alignItems={'center'}>
              <Grid
                xs={1}
                className="d-flex-center"
                item
                style={{
                  fontWeight: 600,
                }}
              >
                {' '}
                THEN
              </Grid>
              <Grid xs={5} item>
                <Select
                  style={{
                    width: '100%',
                    backgroundColor: 'var(--mui-palette-action-hover)',
                    borderRadius: '4px',
                    height: '36px',
                    color: 'var(--mui-palette-text-secondary)',
                  }}
                  name="selectFunc"
                  value={condition.then.Statement.content}
                  onChange={event => {
                    useFormVisibilityStore.getState().setThenContent(event.target.value, indexStatement);
                  }}
                  disableUnderline
                  variant="standard"
                  className="dropdown-mat selectStandard thenMargin"
                  displayEmpty
                >
                  <MenuItem value={true}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Visibility sx={{ color: 'text.primary' }} />
                      <div style={{ marginLeft: '5px' }}> Show this question</div>
                    </div>
                  </MenuItem>
                  <MenuItem value={false}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <VisibilityOff sx={{ color: 'text.primary' }} />
                      <div style={{ marginLeft: '5px' }}> Hide this question</div>
                    </div>
                  </MenuItem>
                </Select>
              </Grid>
            </Grid>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Grid container item xs={12} direction={'row'}>
              <Grid
                xs={5}
                container
                direction={'row'}
                item
                className="text-button"
                alignItems={'center'}
                onClick={() => useFormVisibilityStore.getState().addStatement()}
              >
                <AddIcon /> Add ELSE IF statement
              </Grid>
            </Grid>
            <Grid container xs={12} item direction={'row'} alignItems={'center'}>
              <Grid
                xs={1}
                className="d-flex-center"
                item
                style={{
                  fontWeight: 600,
                }}
              >
                {' '}
                ELSE
              </Grid>
              <Grid xs={11} item>
                <Select
                  style={{
                    width: '100%',
                    backgroundColor: 'var(--mui-palette-action-hover)',
                    borderRadius: '4px',
                    height: '36px',
                    color: 'var(--mui-palette-text-secondary)',
                  }}
                  name="selectFunc"
                  value={condition.then.Statement.content}
                  onChange={event => {
                    useFormVisibilityStore.getState().setThenContent(event.target.value, indexStatement);
                  }}
                  disableUnderline
                  variant="standard"
                  labelId="demo-simple-select-outlined-label"
                  className="dropdown-mat selectStandard"
                  displayEmpty
                >
                  <MenuItem value={true}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Visibility sx={{ color: 'text.primary' }} />
                      <div style={{ marginLeft: '5px' }}> Show this question</div>
                    </div>
                  </MenuItem>
                  <MenuItem value={false}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <VisibilityOff sx={{ color: 'text.primary' }} />
                      <div style={{ marginLeft: '5px' }}> Hide this question</div>
                    </div>
                  </MenuItem>
                </Select>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
      </Grid>
    );
  }
}

export default ItemStatementCondition;
